<div class="card">
    <p-toolbar>
        <ng-form [formGroup]="remindersToggleForm">
            <div class="inputswitch">
                <p-checkbox [(ngModel)]="reminderStatus" formControlName="remindersEnabled"
                    [binary]="true"></p-checkbox>
                <h3>
                    Reminders -
                    <span>
                        {{
                        remindersToggleForm.controls['remindersEnabled'].value
                        ? 'On'
                        : 'Off'
                        }}
                    </span>
                </h3>
            </div>
        </ng-form>
        <button pButton pRipple severity="primary" (click)="ShowAdd.emit()" label="Add Reminder"></button>
    </p-toolbar>

    <!-- main content -->
    <p-table stripedRows #dtReminder [value]="items" id="dtReminder"
        dataKey="Reminderinstanceid" editMode="row"
        [tableStyle]="{ 'min-width': '130em' }">
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="13" style="text-align: center">
                    <div class="tabulator-placeholder">
                        <span> No Data Available </span>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template #header>
            <tr>
                <!-- Edit -->
                <th class="edit-cell"></th>
                <!-- status-->
                <th class="status-cell">
                    <i class="pi pi-exclamation-circle" title="Status"></i>
                </th>
                <!-- Reminder Type -->
                <th>
                    Reminder Type
                    <p-sortIcon pSortableColumn="Title" field="Title" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter field="Remindertypeid" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                        <ng-template #filter let-value let-filter="filterCallback">
                            <p-multiSelect  defaultLabel="Filter" maxSelectedLabels="1" appendTo="body" [options]="reminderTypes" [filter]="true"
                            styleClass="w-full"
                                [ngModel]="value"
                                (ngModelChange)="filter($event)"></p-multiSelect>
                        </ng-template>
                    </p-columnFilter>
                </th>
                <!-- Reminder Name -->
                <th>
                    Reminder Name
                    <p-sortIcon pSortableColumn="Reminderinstancename" field="Reminderinstancename"
                            ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter type="text" matchMode="contains" field="Reminderinstancename" display="menu" class="ml-auto" />
                </th>
                <!-- Review Period -->
                <th>
                    Review Period
                    <p-sortIcon pSortableColumn="Reminderreviewperiodname" field="Reminderreviewperiodname"
                            ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <!-- Reminder Recipient -->
                <th>
                    Reminder Recipient
                    <p-sortIcon pSortableColumn="Groupname" field="Groupname" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <!-- Notify Supervisor -->
                <th>
                    Notify Supervisor
                    <p-sortIcon pSortableColumn="" field="" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <!-- Send ON -->
                <th>
                    Send ON
                    <p-sortIcon pSortableColumn="ReminderScheduleID" field="ReminderScheduleID"
                            ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <!-- Send @ -->
                <th>
                    Send &#64;
                    <p-sortIcon pSortableColumn="Scheduletime" field="Scheduletime" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <!-- Email Subject -->
                <th>
                    Email Subject
                    <p-sortIcon pSortableColumn="Subject" field="Subject" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <!-- Email Text -->
                <th>
                    Email Text
                    <p-sortIcon pSortableColumn="Sendmessage" field="Sendmessage" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <!-- Action -->
                <th>
                    Action
                </th>
                <!-- Run Now -->
                <th>
                    Run Now
                </th>
            </tr>
        </ng-template>
        <ng-template #body let-item let-edit="editing" let-ri="rowIndex">
            <tr [pEditableRow]="item" data-id="row-{{ item.Reminderinstanceid }}">
                <!-- Edit -->
                <td class="edit-cell">
                    <button *ngIf="
                            !edit &&
                            (!editing?.Reminderinstanceid ||
                                editing?.Reminderinstanceid ===
                                    item?.Reminderinstanceid)
                        " pButton type="button" pInitEditableRow icon="pi pi-pencil"
                        class="p-button-rounded p-button-text" (click)="onRowEditInit(item)" title="Edit"></button>
                    <button *ngIf="edit" pButton type="button" pSaveEditableRow icon="pi pi-check"
                        class="p-button-rounded p-button-text p-button-success"
                        (click)="onRowEditSave(item)"></button>
                    <button *ngIf="edit" pButton type="button" pCancelEditableRow icon="pi pi-times"
                        class="p-button-rounded p-button-text p-button-danger"
                        (click)="onRowEditCancel(item)"></button>
                </td>
                <!-- status-->
                <td class="status-cell">
                    <a (click)="
                            ShowError.next({
                                open: !!item.Reminderinstanceid,
                                MsgEntityID: item.Reminderinstanceid,
                                MsgProcessID: process?.ProcessID
                            })
                        ">
                        <div>
                            <ef-status-icon [status]="item?.Status?.StatusCode"
                                [message]="item?.Status?.Message"></ef-status-icon>
                        </div>
                    </a>
                </td>
                <!-- Reminder Type -->
                <td>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <div>
                                <p-select [style]="{ 'min-width': '100%' }" [virtualScroll]="true" itemSize="32"
                                    appendTo="body" [options]="reminderTypes" [filter]="true"
                                    [(ngModel)]="item.Remindertypeid"></p-select>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="output">
                            <div data-toggle="tooltip" data-placement="top" [attr.title]="
                                    (
                                        reminderTypes
                                        | itemlookup
                                            : 'value'
                                            : item?.Remindertypeid
                                    )?.label
                                ">
                                {{
                                (
                                reminderTypes
                                | itemlookup
                                : 'value'
                                : item?.Remindertypeid
                                )?.label
                                }}
                            </div>
                        </ng-template>
                    </p-cellEditor>
                </td>
                <!-- Reminder Name -->
                <td>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <div>
                                <input pInputText type="text" [(ngModel)]="item.Reminderinstancename" required />
                            </div>
                        </ng-template>
                        <ng-template pTemplate="output">
                            <div data-toggle="tooltip" data-placement="top" [attr.title]="item.Reminderinstancename">
                                {{ item.Reminderinstancename }}
                            </div>
                        </ng-template>
                    </p-cellEditor>
                </td>
                <!-- Review Period -->
                <td>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <div>
                                <p-select [virtualScroll]="true" itemSize="32" appendTo="body"
                                    [options]="reminderReviewPeriods" [filter]="true"
                                    [(ngModel)]="item.Reminderreviewperiod"></p-select>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="output">
                            <div data-toggle="tooltip" data-placement="top" [attr.title]="
                                    (
                                        reminderReviewPeriods
                                        | itemlookup
                                            : 'value'
                                            : item?.Reminderreviewperiod
                                    )?.label
                                ">
                                {{
                                (
                                reminderReviewPeriods
                                | itemlookup
                                : 'value'
                                : item?.Reminderreviewperiod
                                )?.label
                                }}
                            </div>
                        </ng-template>
                    </p-cellEditor>
                </td>
                <!-- Reminder Recipient -->
                <td>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <div>
                                <p-select [virtualScroll]="true" itemSize="32" appendTo="body" [options]="
                                        groupsForReminderType(
                                            item.Remindertypeid
                                        )
                                    " [filter]="true" [(ngModel)]="item.Groupid"></p-select>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="output">
                            <div data-toggle="tooltip" data-placement="top" [attr.title]="
                                    (
                                        recipients
                                        | itemlookup: 'GroupID':item?.Groupid
                                    )?.GroupName
                                ">
                                {{
                                (
                                recipients
                                | itemlookup: 'GroupID':item?.Groupid
                                )?.GroupName
                                }}
                            </div>
                        </ng-template>
                    </p-cellEditor>
                </td>
                <!-- Notify Supervisor -->
                <td>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <p-checkbox binary="true" [(ngModel)]="item.Notifysupervisor"></p-checkbox>
                        </ng-template>
                        <ng-template pTemplate="output">
                            <i class="tickcross" [ngClass]="{
                                    fa: true,
                                    'fa-check': item.Notifysupervisor,
                                    'fa-times': !item.Notifysupervisor
                                }"></i>
                        </ng-template>
                    </p-cellEditor>
                </td>
                <!-- Send ON -->
                <td>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <div>
                                <p-select [virtualScroll]="true" itemSize="32" appendTo="body"
                                    [options]="reminderScheduleTypes" [filter]="true"
                                    [(ngModel)]="item.ReminderScheduleID"></p-select>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="output">
                            <div data-toggle="tooltip" data-placement="top" [attr.title]="
                                    (
                                        reminderScheduleTypes
                                        | itemlookup
                                            : 'value'
                                            : item?.ReminderScheduleID
                                    )?.label
                                ">
                                {{
                                (
                                reminderScheduleTypes
                                | itemlookup
                                : 'value'
                                : item?.ReminderScheduleID
                                )?.label
                                }}
                            </div>
                        </ng-template>
                    </p-cellEditor>
                </td>
                <!-- Send @ -->
                <td>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <div>
                                <p-calendar [(ngModel)]="item.Scheduletime" [timeOnly]="true" appendTo="body"
                                    showTime="true" hourFormat="12"></p-calendar>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{
                            moment(item.Scheduletime).isValid()
                            ? moment(item.Scheduletime).format(
                            'hh:mm a'
                            )
                            : item.ScheduleTime
                            }}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <!-- Email Subject -->
                <td>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="item.Subject" required />
                        </ng-template>
                        <ng-template pTemplate="output">
                            <div data-toggle="tooltip" data-placement="top" [attr.title]="item.Subject">
                                {{ item.Subject }}
                            </div>
                        </ng-template>
                    </p-cellEditor>
                </td>
                <!-- Email Text -->
                <td>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="item.Comment" required />
                        </ng-template>
                        <ng-template pTemplate="output">
                            <div data-toggle="tooltip" data-placement="top" [attr.title]="item.Comment">
                                {{ item.Comment }}
                            </div>
                        </ng-template>
                    </p-cellEditor>
                </td>
                <!-- Action -->
                <td>
                    <p-cellEditor>
                        <ng-template pTemplate="input"> </ng-template>
                        <ng-template pTemplate="output">
                            <button pButton type="button" pSaveEditableRow icon="pi pi-trash"
                                class="p-button-rounded p-button-text p-button-danger" (click)="onDelete(item)"
                                style="font-size: 1rem" title="Delete"></button>
                        </ng-template>
                    </p-cellEditor>
                    <!-- Action -->
                </td>
                <!-- Run Now -->
                <td>
                    <p-cellEditor>
                        <ng-template pTemplate="input"> </ng-template>
                        <ng-template pTemplate="output">
                            <button class="btn btn-link" (click)="RunNow.emit(item)" title="Run Now">
                                Run Now
                            </button>
                        </ng-template>
                    </p-cellEditor>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
